import { isMobile } from 'is-mobile'

import { PlatformDevice } from './constants'

export default function getDeviceFromUserAgent(userAgent: string): PlatformDevice {
  if (isMobile({ ua: userAgent })) {
    return PlatformDevice.MOBILE
  }

  return PlatformDevice.DESKTOP
}
